import { defineMessages } from 'react-intl';

export default defineMessages({
  add: {
    defaultMessage: 'Add',
    id: 'app.buttons.add'
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'app.buttons.cancel'
  },
  delete: {
    defaultMessage: 'Delete',
    id: 'app.buttons.delete'
  },
  dismiss: {
    defaultMessage: 'Dismiss',
    id: 'app.buttons.dismiss'
  },
  edit: {
    defaultMessage: 'Edit',
    id: 'app.buttons.edit'
  },
  login: {
    defaultMessage: 'Login',
    id: 'app.buttons.login'
  },
  logout: {
    defaultMessage: 'Logout',
    id: 'app.buttons.logout'
  },
  save: {
    defaultMessage: 'Save',
    id: 'app.buttons.save'
  },
  signUp: {
    defaultMessage: 'Sign Up',
    id: 'app.buttons.signUp'
  },
  submit: {
    defaultMessage: 'Submit',
    id: 'app.buttons.submit'
  }
});



// WEBPACK FOOTER //
// ./src/common/app/buttonsMessages.js